<style>
	.notfcn{border: 1px solid #dedede;
	padding: 5px;
	background: #e28800;
	color: #ffffff;
	text-align: center;
	padding-top: 11px !important;
	border-radius: 6px;}
	.notfcn b{color: #ffffff;}

	.blinking{
		
		height: 50px;
	    
		padding: 15px;	
		text-align: center;
		line-height: 50px;
	}
	.blinking span{
		font-size: 25px;
		font-family: cursive;
		color: white;
		animation: blink 1s linear infinite;
	}
@keyframes blink{
0%{opacity: 0;}
50%{opacity: .5;}
100%{opacity: 1;}
}
 </style>
<div class="card">
	<h5 class="card-header">Search Filter</h5>
	<div class="card-body">
		<div class="users-list-filter">
			<form [formGroup]="searchform" autocomplete="off">
				<button class="btn btn-outline-secondary hidden" (click)="profileDataUpdate(modalPU, currentUserId)" id="profileDatabtn" #profileDatabtn type="button" rippleEffect></button>
				<div class="row">
					<div class="col-12 col-md-3">
						<fieldset class="form-group">
							<input type="text" formControlName="ApplicationNumber" class="form-control"
								(change)="search()" placeholder="Search By Application Number">
						</fieldset>
					</div>
					<div class="col-12 col-md-3">
						<fieldset class="form-group">
							<input type="text" formControlName="SearchText" class="form-control"
								(change)="search()" placeholder="Search By Name">
						</fieldset>
					</div>
					<div class="col-12 col-md-3">
						<fieldset class="form-group">
							<ng-select [items]="projectType" bindLabel="projectTypeName"
								bindValue="projectTypeID" formControlName="ProjectType"
								placeholder="Project Type" (change)="search()">
							</ng-select>
						</fieldset>
					</div>
					<div class="col-12 col-md-3">
						<fieldset class="form-group">
							<ng-select [items]="stageType" bindLabel="stageTypeName"
								bindValue="stageTypeID" formControlName="Stage"
								placeholder="Project Stage" (change)="search()">
							</ng-select>
						</fieldset>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-md-3">
						<fieldset class="form-group">
							<input type="text" formControlName="PrincipalImplementingOrganizations"
								class="form-control" (change)="search()"
								placeholder="Principal Implementing Organizations">
						</fieldset>
					</div>
					<div class="col-12 col-md-3">
						<ng-select [items]="categoryOfInstitution" bindLabel="categoryOfInstitutionName"
							bindValue="categoryOfInstitutionID" placeholder="Category Of Institution"
							formControlName="CategoryOfInstitution" (change)="search()"> </ng-select>
					</div>
					<div class="col-12 col-md-3">
						<fieldset class="form-group">
							<div class="input-group">
								<input class="form-control" placeholder="Start Date (dd-mm-yyyy)" name="startDate"
									formControlName="StartDate" ngbDatepicker #MinMaxDP="ngbDatepicker"
									[minDate]="{year: minDate.year, month: minDate.month, day:minDate.day}"
									[maxDate]="{year: maxDate.year, month: maxDate.month, day:maxDate.day}"
									[readonly]="true" />
								<div class="input-group-append">
									<button class="btn btn-outline-secondary feather icon-calendar"
										(click)="setStartMinDate(); MinMaxDP.toggle();" type="button"
										rippleEffect></button>
								</div>
							</div>
						</fieldset>
					</div>
					<div class="col-12 col-md-3">
						<fieldset class="form-group">
							<div class="input-group">
								<input class="form-control" placeholder="End Date (dd-mm-yyyy)" name="endDate"
									formControlName="EndDate" ngbDatepicker #MinMaxDP1="ngbDatepicker"
									[minDate]="{year: endminDate.year, month: endminDate.month, day: endminDate.day}"
									[maxDate]="{year: maxDate.year, month: maxDate.month, day:maxDate.day}"
									[readonly]="true" />
								<div class="input-group-append">
									<button class="btn btn-outline-secondary feather icon-calendar"
										(click)=" setEndMinDate(); MinMaxDP1.toggle();" type="button"
										rippleEffect></button>
								</div>
							</div>
						</fieldset>
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-md-3">
						<fieldset class="form-group">
							<ng-select [items]="statusType" bindLabel="statusTypeName"
								bindValue="statusTypeID" formControlName="Status"
								placeholder="Project Status" (change)="search()">
							</ng-select>
						</fieldset>
					</div>
					<div class="col-12 col-md-3">
						<fieldset class="form-group"> 
							<ng-select [items]="subjectType" bindLabel="subjectTypeName"
								bindValue="subjectTypeID" formControlName="Subject" 
								[closeOnSelect]="true"
								placeholder="Subject Type" (change)="search()">
							</ng-select> 
							<!-- </ng-select> [multiple]="true" -->
						</fieldset>
					</div>
					<div class="col-12 col-md-3" *ngIf="isAdmin">
						<fieldset class="form-group">
							<ng-select [items]="pageSizeList" bindLabel="pageSizeValue"
								bindValue="pageSizeValue" placeholder="Page Size" formControlName="PageSize"
								(change)="search()"> </ng-select>
						</fieldset>
					</div>
					<div class="col-12 col-md-3" *ngIf="isAdmin">
						<fieldset class="form-group">
							<ng-select [items]="sortByList" bindLabel="sortByName" bindValue="sortByValue"
								placeholder="Sort Order" formControlName="SortOrder" (change)="search()">
							</ng-select>
						</fieldset>
					</div>
				</div>
				<div class="row" *ngIf="isAdmin">
					<div class="col-12 col-md-3">
						<fieldset class="form-group">
							<input type="text" formControlName="institute"
								class="form-control" (change)="search()"
								placeholder="Search By Institute">
						</fieldset>
					</div>
				</div>
				<div class="row">
					<div class="col-12" style="text-align: center;">
						<button type="button" rippleeffect="" (click)="search()"
							class="btn btn-primary mr-1 waves-effect waves-float waves-light">Search</button>
						<button type="reset" rippleeffect="" (click)="resetFilter()"
							class="btn btn-outline-secondary waves-effect mr-1">Reset</button>
						<button type="button" rippleeffect="" 
							class="btn btn-primary waves-effect mr-1" (click)="downloadSummaryReport()" *ngIf="fromPageType == applicationFromMyApplication && isAdmin">Download Summary Report</button>
						<button rippleeffect="" (click)="generateMeetingAgenda()" *ngIf="fromPageType == applicationFromMeetingAgenda"
							class="btn btn-primary  waves-effect waves-float waves-light">Generate Meeting Agenda</button>		
						<button rippleeffect="" (click)="downloadMis()" *ngIf="fromPageType == applicationFromMisReport"
							class="btn btn-primary  waves-effect waves-float waves-light">Download MIS Report</button>						
					</div>
					<!-- <div *ngIf="this.isUser || isAdmin" class="col-2" >
						<button style="float:left" type="button" routerLink="/coe-application"
						class="btn btn-primary mr-1 waves-effect waves-float waves-light">COEs Applications</button></div> -->
						<div *ngIf="this.isUser || isAdmin" class="col-8" >
							<button style="float:left" type="button" routerLink="/euttc-application"
							class="btn btn-primary mr-1 waves-effect waves-float waves-light">EU-TTC Applications</button></div>
					<!-- <div *ngIf="this.isUser" class="col-6" ><button *ngIf="!hideButton" style="float:right" type="button" routerLink="/coe-proposal"
							class="btn btn-primary mr-1 waves-effect waves-float waves-light">Apply for COEs Proposal</button></div> -->
					<div *ngIf="this.isUser" class="col-4" >
					<div class="blinking" style="text-align: end; padding-top: 7px; font: bold;"> <span class="" style="color: #e28800; font-size: 33px; font-weigth: 700px"><i class="fa fa-hand-o-right"></i>&nbsp; </span>
					<button *ngIf="!hideButton" style="float:right" type="button" routerLink="/euttc-proposal"
							class="btn btn-primary mr-1 waves-effect waves-float waves-light"> Apply for EU-TTC Proposal</button></div></div>
				</div>
			</form>
		</div>
	</div>
</div>
<section class="app-ecommerce-details">
	<h5 class="font-weight-bolder">TOTAL APPLICATION FOUND: {{totalRecords}}</h5>
	<div class="card" *ngFor="let item of applicatinList; let $index=index">
		<!-- Related Products starts -->
		<div class="card-body">
			<div class="row row-card-outer-container">
				<div class="row-card-inner-container" [ngClass]="(fromPageType === applicationFromMeetingAgenda ||
				fromPageType === applicationFromMisReport) ? 'col-6' : 'col-3'">
					<div class="row">
						<div class="col-1" *ngIf="fromPageType == applicationFromMeetingAgenda">
							<input type="checkbox" class="checkboxstyle" *ngIf="fromPageType == applicationFromMeetingAgenda" [value]="item.id" (change)="onCheckboxChange($event)"/>
						</div>
						<div [ngClass]="fromPageType === applicationFromMeetingAgenda ? 'col-11' : 'col-12'">
							<div class="custom-control">
								<h2><b><a routerLink="/my-application/view/{{ item.encodeId }}">{{item.principleInvestigator}}</a></b></h2>
								<span>{{item.subjectArea}}</span>
								
							</div>
						</div>
					</div>
				</div>
				<div class="col-3 row-card-inner-container" *ngIf="fromPageType == applicationFromMyApplication">
					<div class="row">
						<div class="col-4" style="text-align: right;
						vertical-align: middle;
						margin-top: 10px;">
							<a href="javascript:void(0)" *ngIf="item?.hasMessageList"   (click)="viewMessage(modalSM, item.encodeId)" title="View Message"><b>View All</b></a>
						</div>
						<div class="col-4">
							<div class="btn-group" style="float: right;">

								<!-- <div class="col-12 col-form-label d-flex justify-content-end actions_icons" style="padding-right: 25px;"> 
									<a style="padding:0 10px; text-align:center;" href="#"> <img src="assets/images/icons/submit.png" alt=""> <br> Submit </a>
		
										<a style="padding:0 10px; text-align:center;" href="#"> <img src="assets/images/icons/edit.png" alt=""> <br> Edit</a>
										<a style="padding:0 10px; text-align:center;" href="#"> <img src="assets/images/icons/preview.png" alt=""> <br> Preview</a>
		
										
									
									
								</div> -->
								<div ngbDropdown>
									<button ngbDropdownToggle type="button" class="btn btn-primary"
										rippleEffect>Action</button>
									<div ngbDropdownMenu>
										<a href="javascript:void(0)" *ngIf="item.isEdit != 0 || (this.isUser && (item.isQueryGenerated) && (item.stage.length > 0 && !item.stage[1].status))"
										ngbDropdownItem routerLink="/apply-online/{{ item.encodeId }}">Edit Application</a>

										<a href="javascript:void(0)" *ngIf="this.isUser && item.isEdit != 1 && item.isUserEdit !=0" 
										ngbDropdownItem routerLink="/apply-online/{{ item.encodeId }}">Edit Application</a>

										<a href="javascript:void(0)" ngbDropdownItem
											*ngIf="this.isExpert && (item.stage.length > 0 && item.stage[0].status)"
											(click)="expertEvalution(modalExpertEvalution, item.encodeId, item.projectTitle)">Expert Evaluation Sheet</a>
										<a href="javascript:void(0)"
											*ngIf="this.isUser  && (item.stage.length > 0 && !item.stage[0].status)"
											ngbDropdownItem
											(click)="uploadSignedDocument(modalDC, item.id)">Upload Signed Application</a>

											<a href="javascript:void(0)"
											*ngIf="this.isUser && item.isEdit != 1 && item.isUserEdit !=0"
											ngbDropdownItem
											(click)="uploadSignedDocument(modalDC, item.id)">Upload Signed Application</a>
									
										<a href="javascript:void(0)"
											*ngIf="this.isAdmin && (item.stage.length > 2 && !item.stage[3].status) && item.expertCommentsStatus == 'Accept'"
											ngbDropdownItem (click)="raiseRequestAgenda(modalRR, item.id)">Raise Mandate Request
										</a>
										<a href="javascript:void(0)" *ngIf="this.isAdmin && (item.stage.length > 0 && item.stage[2].status)
											&& item.expertCommentsStatus === 'Accept'" ngbDropdownItem (click)="uploadSanctionLatter(modalSL, item.id)">Upload
											Sanction Latter</a>
										<a href="javascript:void(0)" *ngIf="this.isUser && (item.stage.length > 5 && item.stage[1].status)
											&& item.status === 'Accept' && !item.stage[5].status " ngbDropdownItem routerLink="/my-application/progress-report/{{ item.encodeId }}">
											Progress Report</a>
										<a href="javascript:void(0)"
											*ngIf="this.isUser && (item.stage.length >= 4 && item.stage[2].status)"
											ngbDropdownItem
											routerLink="/my-application/mandate-form/{{ item.encodeId }}">
											Mandate Form</a>
										<a href="javascript:void(0)"
											*ngIf="this.isUser && item.progressReportId && item.stage.length > 5 && !item.stage[5].status"
											routerLink="/my-application/completion-report/{{ item.encodeId }}"
											ngbDropdownItem>Completion Report</a>

										<a href="javascript:void(0)" *ngIf="this.isAdmin && (item.stage.length > 5)
											&& item.status === 'Accept'"
											(click)="progressReportStatus(modalPR, item.id,item.progressReportId, item.encodeId)"
											ngbDropdownItem>Approve/Reject Progress Report</a>

										<a href="javascript:void(0)"
											*ngIf="this.isAdmin && (item.stage.length > 2 && item.stage[1].status) && item.status == 'Accept'"
											ngbDropdownItem
											routerLink="/my-application/meeting-agenda/{{ item.encodeId }}">Generate Meeting Agenda
										</a>
										<a href="javascript:void(0)" ngbDropdownItem
										*ngIf="this.isAdmin && (item.stage.length > 0 && !item.stage[1].status)"
										(click)="forwardToExpert(modalVC, item.id)">Forward to Expert</a>

										<a href="javascript:void(0)" *ngIf="this.isAdmin && (item.stage.length > 0 && !item.stage[1].status)
											&& item.status != 'Accept'" ngbDropdownItem (click)="actionOnExpertComment(modalAR, item.id, item.encodeId)">Approve
											Expert Comments</a>
										<a href="javascript:void(0)" *ngIf="this.isUser && (item.stage.length > 0 && item.stage[0].status)"
										(click)="uploadDocument(modalUDC, item.encodeId)" ngbDropdownItem>Upload Document</a>
										<a href="javascript:void(0)" *ngIf="this.isAdmin"
											(click)="sendMessage(modalSM, item.encodeId)" ngbDropdownItem>Send Message</a>
											<a href="javascript:void(0)" *ngIf="this.isUser && (item.isQueryGenerated) && (item.stage.length > 0 && !item.stage[1].status)"
												(click)="sendMessage(modalSM, item.encodeId)" ngbDropdownItem>Reply Message</a>
									</div>
								</div>
							</div>
						</div>
						<div class="col-4">
							<div class="btn-group">
								<div ngbDropdown>
									<button ngbDropdownToggle type="button" class="btn btn-primary"
										rippleEffect>Download</button>
									<div ngbDropdownMenu>
										<div *ngIf="item.applicationPdfUrl">
											<a href="{{item.applicationPdfUrl}}" target="_blank"
													ngbDropdownItem>Download Application Pdf</a>
										</div>
										<div *ngIf="item.signedDocumentUrl">
											<a href="{{item.signedDocumentUrl}}" target="_blank"
													ngbDropdownItem>Download Signed Document</a>
										</div>
										<div *ngIf="item.applicationPdfUrl && (this.isAdmin || this.isUser)" >
											<a href="javascript:void(0)" (click)="downloadApplicationSummaryPdf(item.id)" 
													ngbDropdownItem>Download Summary pdf</a>
										</div>
										<div *ngIf="item.applicationPdfUrl && this.isAdmin" >
											<a href="javascript:void(0)" (click)="downloadApplicationSummaryPdf(item.id)" 
													ngbDropdownItem>Download Summary pdf</a>
										</div>
										<div *ngIf="item.sanctionDocumentUrl">
											<a href="{{item.sanctionDocumentUrl}}" target="_blank"
													ngbDropdownItem>Download Sanction Letter</a>
										</div>
										<div *ngIf="item.sanctionDocumentUrl && item.stage.length == 6 && item.stage[5].status ">
											<a href="{{item.completionReportUrl}}" target="_blank"
													ngbDropdownItem>Download Completion Report pdf</a>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-3 row-card-inner-container">
					<div class="row">
						<div class="col-3 col-form-label" style="text-align: right;">
							<label><b>Status</b></label>
						</div>
						<div class="col-9 col-form-label notfcn">
							<label style="font-size: 16px; padding-top: 8px;" [ngClass]="{ 'reject': (item.status === 'Reject' || item.statusList === 'Application not shortlisted')
							, 'accept': (item.status === 'Accept' || item.statusList === 'Accepted'), 'pending': item.status === 'Pending' }">
								<b>{{item?.statusList}}</b></label>
						</div>
					</div>
				</div>
				<div class="col-3 row-card-inner-container">
					<div class="row">
						<div class="col-6 col-form-label">
							<label><b>Created Date</b></label>
						</div>
						<div class="col-6 col-form-label">
							<p class="text-justify">{{item.createdAt}}</p>
						</div>
					</div>
					<div class="row">
						<div class="col-6 col-form-label">
							<label><b>Modified Date</b></label>
						</div>
						<div class="col-6 col-form-label">
							<p class="text-justify">{{item?.modifiedAt}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row row-card-outer-container" style="margin-top: 15px;">
				<div class="col-3 row-card-inner-container">
					<div class="row">
						<div class="col-6 col-form-label">
							<label><b>Application No.</b></label>
						</div>
						<div class="col-6 col-form-label">
							<input type="hidden" id="{{$index + 1}}_applicationID" value="{{item.id}}">
							<p class="text-justify">{{item.applicationNumber}}</p><br />
						</div>
					</div>
				</div>
				<!-- <div class="col-3">
					<div class="row">
						<div class="col-6 col-form-label">
							<label><b>Co-Principal Investigator:</b></label>
						</div>
						<div class="col-6 col-form-label">
							<p class="text-justify">{{item.coPrincipalInvestigator}}</p>
						</div>
					</div>
				</div> -->
				<div class="col-6 row-card-inner-container">
					<div class="row">
						<div class="col-3 col-form-label">
							<label><b>Project Title</b></label>
						</div>
						<div class="col-9 col-form-label">
							<p class="text-justify">{{item.projectTitle}}</p>
						</div>
					</div>
				</div>
				<div class="col-3 row-card-inner-container">
					<div class="row">
						<div class="col-6 col-form-label">
							<label><b>Project Type</b></label>
						</div>
						<div class="col-6 col-form-label">
							<p class="text-justify">{{item.projectType}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row row-card-outer-container">
				<div class="col-3 row-card-inner-container">
					<div class="row">
						<div class="col-6 col-form-label">
							<label><b>Duration (Month)</b></label>
						</div>
						<div class="col-6 col-form-label">
							<p class="text-justify">{{item.duration}}</p>
						</div>
					</div>
				</div>
				<div class="col-3 row-card-inner-container">
					<div class="row">
						<div class="col-6 col-form-label">
							<label><b>Principal Implementing Organization (s)</b></label>
						</div>
						<div class="col-6 col-form-label">
							<p class="text-justify">{{item.principalImplementingOrganization}}</p>
						</div>
					</div>
				</div>
				<div class="col-3 row-card-inner-container">
					<div class="row">
						<div class="col-6 col-form-label">
							<label><b>Category of Implementing Institution (s)</b></label>
						</div>
						<div class="col-6 col-form-label">
							<p class="text-justify">{{item.categoryImpInstitution}}</p>
						</div>
					</div>
				</div>
				<div class="col-3 row-card-inner-container">
					<div class="row">
						<div class="col-6 col-form-label">
							<label><b>Darpan Portal RegistrationID</b></label>
						</div>
						<div class="col-6 col-form-label">
							<p class="text-justify">{{item.darpanPortlRegisterID}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="row row-card-outer-container">
				<div class="col-3 row-card-inner-container">
					<div class="row">
						<div class="col-6 col-form-label">
							<label><b>Collaborating Organizations</b></label>
						</div>
						<div class="col-6">
							<p class="text-justify">{{item.collaboratingOrg}}</p>
						</div>
					</div>
				</div>
				<div class="col-3 row-card-inner-container">
					<div class="row">
						<div class="col-6 col-form-label">
							<label><b>Share of implementing/ participating Institutions in the total cost (Rs.)</b></label>
						</div>
						<div class="col-6 col-form-label">
							<p class="text-justify">{{item.shareImplementing}}</p>
						</div>
					</div>
				</div>
				<div class="col-3 row-card-inner-container">
					<div class="form-group row">
						<div class="col-6 col-form-label">
							<label><b>Expert Comments Received</b></label>
						</div>
						<div class="col-6 col-form-label">
							<p class="text-justify">{{item.expertCount}}</p>
						</div>
					</div>
				</div>

				<div class="col-3 row-card-inner-container">
					<div class="form-group row">
						<div class="col-6 col-form-label">
							<label><b>Area of Research</b></label>
						</div>
						
						<div class="col-6 col-form-label"> 
							<div class="stepper-wrapper" *ngIf="item.areaOfResearch != null">
								<div *ngIf="item.areaOfResearch; let actual" > 
								<p class="text-justify" *ngIf="actual.includes(1)" > Hydrogen Production</p>
								<p class="text-justify" *ngIf="actual.includes(2)" > Hydrogen Storage</p>
								<p class="text-justify" *ngIf="actual.includes(3)" > Transportation</p>	
								<p class="text-justify" *ngIf="actual.includes(4)" > Applications</p>
								<p class="text-justify" *ngIf="actual.includes(5)" > Safety Cross-cutting Analysis and Integration</p>
								<p class="text-justify" *ngIf="actual.includes(6)" > Others</p>
								</div>
							</div>
							
							
						</div>



					<!-- <div class="stepper-item" *ngFor="let areaOfResearch of item.areaOfResearch">
					<div class="step-counter">{{areaOfResearch}}</div>
					
				     </div> -->
				 </div>
				</div>
				<div class="col-12 row-card-inner-container">
					<div class="form-group row ">
						<!-- <div class="col-6 col-form-label">
							<label><b>Actions</b></label>
						</div> -->
						
						<!-- <div class="col-12 col-form-label d-flex justify-content-end actions_icons" style="padding-right: 25px;"> 
							<a style="padding:0 10px; text-align:center;" href="#"> <img src="assets/images/icons/submit.png" alt=""> <br> Submit </a>

								<a style="padding:0 10px; text-align:center;" href="#"> <img src="assets/images/icons/edit.png" alt=""> <br> Edit</a>
								<a style="padding:0 10px; text-align:center;" href="#"> <img src="assets/images/icons/preview.png" alt=""> <br> Preview</a>

								
							
							
						</div> -->



					<!-- <div class="stepper-item" *ngFor="let areaOfResearch of item.areaOfResearch">
					<div class="step-counter">{{areaOfResearch}}</div>
					
				     </div> -->
				 </div>
				</div>

				<div class="col-3 row-card-inner-container">
					<div class="form-group row">
						<div class="col-6 col-form-label">
							<label><b>Other Area of Research</b></label>
						</div>
						<div class="col-6 col-form-label">
							<p class="text-justify">{{item.otherAreaofResearch}}</p>
						</div>
					</div>
				</div>

			</div>
			<div class="stepper-wrapper" *ngIf="item.stage.length > 0">
				<div class="stepper-item" [ngClass]="{ 'completed': stage.status }"
					*ngFor="let stage of item.stage">
					<div class="step-counter">{{stage.id}}</div>
					<div class="step-name">{{stage.paraDescription}}</div>
				</div>
			</div>
		</div>
	</div>
	<div class="card" *ngIf="applicatinList.length == 0">
		<div class="card-body">
			<span>No records found.</span>
		</div>
	</div>
	<div *ngIf="applicatinList.length > 0">
		<ngb-pagination [collectionSize]="totalRecords" class="d-flex justify-content-center"
			[(page)]="pageAdvancedEllipses" [maxSize]="5" [rotate]="true" [boundaryLinks]="true"
			[pageSize]="pageSize" (pageChange)="loadPage($event)">
			<ng-template ngbPaginationFirst>First</ng-template>
			<ng-template ngbPaginationPrevious><span [data-feather]="'chevron-left'"
					[class]="'font-weight-bolder'"></span>Prev
			</ng-template>
			<ng-template ngbPaginationNext>Next<span [data-feather]="'chevron-right'"
					[class]="'font-weight-bolder'"></span>
			</ng-template>
			<ng-template ngbPaginationLast>Last</ng-template>
		</ngb-pagination>
	</div>
</section>



<!-- Modal -->
<ng-template #modalVC let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="exampleModalCenterTitle">Forword to Expert</h5>
		<button type="button" class="close" (click)="closeModal(); modal.dismiss('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" tabindex="0" ngbAutofocus>
		<form [formGroup]="forwordtoexpertform" autocomplete="off">
			<div class="form-group col-md-12">
				<label for="subjectType" class="form-label">Category<span class="required-asterisk">*</span></label>
				<ng-select [items]="subjectType" bindLabel="subjectTypeName" bindValue="subjectTypeID" formControlName="Subject" multiple="true"
					[closeOnSelect]="true" placeholder="Select Category" (change)="subjectChange($event,false)" 
					[class.error]="!f2.Subject.valid && submitted">
				</ng-select> 
				<span *ngIf="submitted && f2.Subject.invalid" class="invalid-form">
					<small class="form-text text-danger"  
					*ngIf="f2.Subject.errors.required">This field is required!</small>
				</span>
			</div>
			<div class="form-group col-md-12">
				<label for="department" class="form-label">Department</label>
				<ng-select [items]="department" bindLabel="departmentName" bindValue="departmentID" formControlName="department" multiple="true"
					[closeOnSelect]="true" placeholder="Select Department" (change)="departmentChange($event,false)" >
				</ng-select> 
				<!-- <span *ngIf="submitted && f2.department.invalid" class="invalid-form">
					<small class="form-text text-danger" 
					 *ngIf="f2.department.errors.required">This field is required!</small>
				</span> -->
			</div>
			<div class="form-group col-md-12">
				<label for="CategoryType" class="form-label">Area of Expertise</label>
				<ng-select [items]="CategoryType" bindLabel="categoryTypeName" bindValue="categoryTypeID" formControlName="Category" multiple="true"
					[closeOnSelect]="true" placeholder="Area of Expertise" (change)="loadExpertDetails($event,false)">
				</ng-select> 
				<!-- <span *ngIf="submitted && f2.Category.invalid" class="invalid-form">
					<small class="form-text text-danger" 
					*ngIf="f2.Category.errors.required">This field is required!</small>
				</span> -->
			</div>
			<div class="form-group col-md-12">
				<label class="form-label" for="expert">Expert Name</label>
				<span class="required-asterisk">*</span>
				<div class="form-group">
					<ng-select [items]="expertListArray" bindLabel="name" bindValue="id" multiple="true" [class.error]="!f2.Expert.valid && submitted" formControlName="Expert"
						placeholder="Experts Name">
					</ng-select>
					<span *ngIf="submitted && f2.Expert.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="f2.Expert.errors.required">This
							field is required!</small>
					</span>
				</div>
			</div>
			<div class="form-group col-md-12">
				<label class="form-label" for="remarks">Remarks</label>
				<span class="required-asterisk">*</span>
				<div class="form-group">
					<textarea type="text" type="text" name="remarks" id="remarks" placeholder="Remarks"
						formControlName="Remarks" class="form-control"
						[ngClass]="{ 'is-invalid': submitted && !f2.Remarks.valid }"></textarea>
					<span *ngIf="submitted && f2.Remarks.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="f2.Remarks.errors.required">This
							field is required!</small>
						<small class="form-text text-danger" *ngIf="f2.Remarks.errors.pattern">This field contain atleast one alphanumerical value!</small>
					</span>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="submit" class="btn btn-primary" (click)="postData(modal)" rippleEffect>
			Submit
		</button>
	</div>
</ng-template>
<!-- / Modal -->

<ng-template #modalDC let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="exampleModalCenterTitle">Upload Signed Application</h5>
		<button type="button" class="close" (click)="closeModal(); modal.dismiss('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" tabindex="0" ngbAutofocus>
		<form [formGroup]="uploadsigneddocumentform" autocomplete="off">
			<div class="form-group col-md-12">
				<label class="form-label" for="uploadDocument">Upload Document</label>
				<span class="required-asterisk">*</span>
				<div class="form-group">
					<div class="custom-file">
						<input type="file" class="form-control custom-file-input" ng2FileSelect [uploader]="uploader"
							id="file-upload-single" accept=".pdf" (click)="browsbuttonClick('document')"
							(change)="uploadFileChange($event, 'document',25)" formControlName="SignedDocument"
							[ngClass]="{ 'is-invalid': submitted && !f3.SignedDocument.valid }" />
						<label class="custom-file-label" id="SignedDocument" for="file-upload-single"
							aria-placeholder="Upload file">{{f3.SignedDocumentName.value}}</label>
					</div>
					<sup>(Upload PDF of size upto 25MB)</sup>
					<span *ngIf="submitted && f3.SignedDocument.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="f3.SignedDocument.errors.required">This
							field is required!</small>
					</span>
				</div>
			</div>
			<div class="form-group">
				<div class="custom-control custom-checkbox">
				  <input class="custom-control-input" id="summaryCheck" formControlName="summaryCheck" type="checkbox"  />
				  <label class="custom-control-label" for="summaryCheck">I have read all details filled/uploaded in the  <a href="javascript:void(0)" (click)="downloadApplicationSummaryPdf(f3.ApplicationID.value)" 
					>application</a> before submission</label>
				  <span *ngIf="submitted && f3.summaryCheck.invalid" class="invalid-form">
					<small class="form-text text-danger" *ngIf="f3.summaryCheck.errors.required">“ This checkbox field is required!”!</small>
				</span>
				</div>
			  </div>
		</form>
	</div>
	<div class="modal-footer">
		
			<button type="submit" class="btn btn-primary" (click)="uploadDocumentData(modal)" rippleEffect>
				Submit
			</button>
		
		
	</div>
</ng-template>

<!-- Modal -->
<div class="scrolling-content-inside-modal">
	<ng-template #modalExpertEvalution let-modal>
		<div class="modal-header">
			<h5 class="modal-title" id="exampleModalCenterTitle">Expert Evaluation</h5>
			<button type="button" class="close" (click)="closeModal(); modal.dismiss('Cross click')" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-body" tabindex="0" ngbAutofocus>
			<form [formGroup]="expertevalutionform" *ngIf="expertevalutionform" autocomplete="off">
				<div class="row">
					<div class="form-group col-12" style="text-align: right;">
						<span><b><u>Annexure-III</u></b></span>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-12" style="text-align: center;">
						<span><b>Ministry of New and Renewable Energy</b></span>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-12" style="text-align: center;">
						<span><b><u>Proforma for preparation of Expert Comments on R&D/ Technology Development
									Projects</u></b></span>
					</div>
				</div>
				<div class="row" *ngIf="!isViewMode">
					<div class="form-group col-12">
						<span><b>Project Title</b> {{expertevalutionform.controls.ProjectTitle.value}}</span>
					</div>
				</div>
				<div class="row" *ngIf="!isViewMode">
					<div class="form-group col-12">
						<span><b>MNRE Reference:</b></span>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-12">
						<div class="table-responsive table-bordered">
							<table class="table mb-0 table-striped table-bordered">
								<thead>
									<tr>
										<th width="5%" scope="col" class="text-wrap">Sr. No.</th>
										<th width="40%" scope="col" class="text-wrap">Item</th>
										<th width="40%" scope="col" class="text-wrap">Comments of Expert</th>
										<th width="15%" scope="col" class="text-wrap">Rating by Expert/ Max. Rating</th>
									</tr>
								</thead>
								<tbody formArrayName="expertEvalutionArray">
									<tr *ngFor="let item of expertevalutionform.controls.expertEvalutionArray.controls; let $index=index"
										[formGroupName]="$index">
										<td style="text-align: center;">{{$index + 1}}</td>
										<td scope="col" class="text-wrap">
											<input type="hidden" formControlName="parentid">
											{{item.value.parentPara}}
											<ul *ngFor="let childItem of item.value.childPara; let $childIndex=index">
												<li class="text-wrap">
													{{childItem.paraDescription}}
												</li>
											</ul>
										</td>
										<td scope="col" class="text-wrap">
											<textarea class="form-control" type="text" style="height:150px;" [readonly]="isViewMode"
												formControlName="comments" [ngClass]="{ 'is-invalid': submitted && expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['comments'].invalid }"></textarea>
											<span *ngIf="submitted && expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['comments'].invalid || (expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['comments'].touched)"
												class="invalid-form">
												<small class="form-text text-danger"
													*ngIf="expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['comments'].touched && expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['comments'].hasError('pattern')">
										 	 		Atleast one alphanumerical value is required!  
												</small>
												
											</span>
											</td>
										<td scope="col" class="text-wrap">
											<div class="form-inline"
												*ngIf="item.value.rating > 0 && item.value.rating < 100">
												<input class="form-control" type="text" formControlName="givenRating"
													style="width: 50%;" (change)="calculcateTotalRating($index)" 
													[ngClass]="{ 'is-invalid': (expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['givenRating'].touched 
									  && expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['givenRating'].invalid) ||
									  (submitted 
									  && expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['givenRating'].invalid) ||
									  expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['givenRating'].max && this.props.onChange(e.value)}"
													maxlength="2" [mask]="'^([1-9]\\d*|0)$'"
													[disabled]="item.value.isDisabledField" [readonly]="isViewMode" />
												<span style="float: right;">/{{item.value.rating}}</span>
											</div>
											<div class="form-inline"
												*ngIf="item.value.rating > 0 && item.value.rating == 100">
												<span
													style="float: right;">{{this.totalRating}}/{{item.value.rating}}</span>
											</div>
											<span
												*ngIf="submitted && expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['givenRating'].invalid ||
										(expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['givenRating'].touched)"
												class="invalid-form">
												<small class="form-text text-danger"
													*ngIf="expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['givenRating'].touched && 
										  expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['givenRating'].hasError('required')">
													This filed is required!
												</small>
												<small class="form-text text-danger"
													*ngIf="expertevalutionform.controls['expertEvalutionArray'].controls[$index].controls['givenRating'].errors">
													Rating must be between 0 and {{item.value.rating}}
												</small>
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-md-12">
						<div class="row">
							<div class="col-md-6" *ngIf="!isViewMode">
								<div class="row">
									<div class="col-md-10">
										<label class="form-label" for="uploadDocument">Upload Document</label><br />
										<sup>"(Upload PDF of size upto 25MB)"</sup>
										<div class="form-group">
											<div class="custom-file">
												<input type="file" class="custom-file-input" ng2FileSelect
													[uploader]="uploader" id="file-upload-single" accept=".pdf"
													(click)="browsbuttonClick('expertEvalutionDocument')"
													(change)="uploadEvalutionChange($event, 25)" formControlName="EvalutionDocument"
													/>
													<label
													class="custom-file-label"
													for="file-upload-single"
													>{{ f4.EvalutionDocumentName.value }}</label
												>
											</div>
										</div>
									</div>
									<div class="col-md-2 pt-4" *ngIf="expertDocument != '' ">
										<a href="{{expertDocument}}" target="_blank">
											<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
												title="Download"></i>
										</a>
									</div>
								</div>
							</div>
							<div class="col-md-6" *ngIf="isViewMode">
								<div class="col-md-4 pt-4" *ngIf="expertDocument != '' ">
									Download Document
									<a href="{{expertDocument}}" target="_blank">
										<i class="feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download"></i>
									</a>
								</div>
							</div>
							<div class="col-md-6">
								<label class="form-label" for="remarks">Remarks</label>
								<span class="required-asterisk">*</span>
								<div class="form-group">
									<textarea type="text" type="text" name="remarks" id="remarks" placeholder="Remarks"
										formControlName="Remarks" class="form-control" [readonly]="isViewMode"
										[ngClass]="{ 'is-invalid': submitted && !f4.Remarks.valid }"></textarea>
									<span *ngIf="submitted && f4.Remarks.invalid" class="invalid-form">
										<small class="form-text text-danger" *ngIf="f4.Remarks.errors.required">This
											field is required!</small>
										<small class="form-text text-danger" *ngIf="f4.Remarks.errors.pattern">This field contain atleast one alphanumerical value!</small>
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
		<div class="modal-footer" *ngIf="!isViewMode">
			<button type="submit" class="btn btn-primary" (click)="postExpertEvalutionData(modal)" rippleEffect>
				Submit
			</button>
		</div>
	</ng-template>
</div>
<!-- / Modal -->

<ng-template #modalAR let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="exampleModalCenterTitle">Application Status</h5>
		<button type="button" class="close" (click)="closeModal(); modal.dismiss('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" tabindex="0" ngbAutofocus>
		<form [formGroup]="approverejectform" autocomplete="off">
			<div class="form-group col-md-12">
				<fieldset class="border" style="padding: 0.7rem;">
					<legend class="w-auto">
						<h5 style="margin-top: 7px;">View Experts Comments</h5>
					</legend>
					<table class="table table-striped table-bordered">
						<thead>
							<tr>
								<th width="1%">Sr. No.</th>
								<th width="10%">Expert Name</th>
								<th width="20%">Status Updated At</th>
								<th width="20%">Status Updated By</th>
								<th width="40%">Action</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let exp of expertList; let $index = index">
								<td >{{$index + 1}}</td>
								<td class="text-justify"> <a href="Javascript:void(0)" (click)="viewComment(modalExpertEvalution, exp?.id)"><span>{{exp?.name}}</span></a></td>
								<td>
									<div *ngIf="exp.expertStatusUpdatedAt">
										{{exp.expertStatusUpdatedAt}}
									</div>
								</td>
								<td *ngIf="exp.statusUpdatedBy">
									<div *ngIf="exp.statusUpdatedBy">
										{{exp.statusUpdatedBy}}
									</div>
								</td>
								<td>
									<div *ngIf="exp.expertStatus != 2" >
										<span *ngIf="exp.expertStatus == 1" class="accept">Approved</span>
										<span *ngIf="exp.expertStatus == 0" class="reject">Rejected</span>
									</div>
								</td>
								<td *ngIf="exp.expertStatus == 2">
									<button type="button" class="btn btn-primary btn-sm" rippleEffect (click)="updateExpertRemarkStatus(modalEAR,true,exp?.id)">Approve</button> &nbsp;&nbsp;
									<button type="button" class="btn btn-danger btn-sm" rippleEffect (click)="updateExpertRemarkStatus(modalEAR,false,exp?.id)">Reject</button>
								</td>
							</tr>
							<tr *ngIf="expertList?.length == 0">
								<td colspan="5">No details are available.</td>
							</tr>
						</tbody>
					</table>
				</fieldset>
			</div>
			<div class="form-group col-md-12">
				<label class="form-label" for="remarks">Remarks</label>
				<span class="required-asterisk">*</span>
				<div class="form-group">
					<textarea type="text" type="text" name="remarks" id="remarks" placeholder="Remarks"
						formControlName="Remarks" class="form-control"
						[ngClass]="{ 'is-invalid': applicationStatusRemarksubmitted && !f5.Remarks.valid }"></textarea>
					<span *ngIf="applicationStatusRemarksubmitted && f5.Remarks.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="f5.Remarks.errors.required">This
							field is required!</small>
						<small class="form-text text-danger" *ngIf="f5.Remarks.errors.pattern">This field contain atleast one alphanumerical value!</small>
					</span>
				</div>
			</div>
			<div class="col-md-12">
				<label class="form-label" for="status"><b>Application Status</b> </label> &nbsp;&nbsp;&nbsp; <i class="fa fa-info-circle font-medium-5" title="This section allows changing the status of the Application based on the decision of the subject expert's comments " aria-hidden="true"></i>
				<!-- <span class="required-asterisk">*</span> -->
				<div class="row pt-1">
					<div class="form-group col-md-4">
						<button type="button" title="Send Back for Modification" class="btn btn-primary btn-sm" rippleEffect (click)="approveRejectApplication(3,modal)">Send Back for Modification</button>
					</div>
					<div class="form-group col-md-3">
						<button type="button" title="Approve Application For Further Process" class="btn btn-primary btn-sm" rippleEffect (click)="approveRejectApplication(1,modal)">Accept and Process for Documentation</button>
					</div>
					<div class="form-group col-md-2">
						<button type="button" title="Application Not Shortlisted" class="btn btn-danger btn-sm" rippleEffect (click)="approveRejectApplication(2,modal)">Not Shortlisted</button>
					</div>
					<div class="form-group col-md-3">
						<button type="button" title="Forward to Another Expert" class="btn btn-warning btn-sm" rippleEffect (click)="forwardToExpert(modalVC, approverejectform.value.ApplicationID)">Forward to Another Expert</button>
					</div>
					
				</div>
				
				<!-- <div class="demo-inline-spacing" *ngFor="let a of StatusList; let $index=index"
					style="margin-top: -15px;">
					<div class="custom-control custom-radio">
						<input type="radio" id="StatusID{{$index+1}}" formControlName="StatusID" name="StatusID"
							class="custom-control-input" value="{{a.value}}" [checked]="($index === 0)" />
						<label class="custom-control-label" for="StatusID{{$index + 1}}">{{a.label}}</label>
					</div>
				</div>
				<span *ngIf="submitted && f5.StatusID.invalid" class="invalid-form">
					<small class="form-text text-danger" *ngIf="f5.StatusID.errors.required">This
						field is required!</small>
				</span> -->

			</div>
			
		</form>
	</div>
	<div class="modal-footer">
		<!-- <button type="submit" class="btn btn-primary" (click)="approveRejectApplication(modal)" rippleEffect>
			Submit
		</button> -->
	</div>
</ng-template>

<ng-template #modalSL let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="exampleModalCenterTitle">Upload Sanction Letter</h5>
		<button type="button" class="close" (click)="closeModal(); modal.dismiss('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" tabindex="0" ngbAutofocus>
		<form [formGroup]="uploadsanctionlatterform" autocomplete="off">
			<div class="row">
				<div class="col-md-2">
					<button type="accept" (click)="toggleShow('Accept')" class="btn btn-success" rippleEffect>
						Approve
					</button>
				</div>
				<div class="col-md-3">
					<button type="reject" (click)="toggleShow('Reject')" class="btn btn-danger" rippleEffect>
						Reject
					</button>
				</div>
			</div>
			<div *ngIf="isShown" id="divshow">
				<div class="row pt-1">
					<div class="form-group col-md-6 file-field">
						<label class="form-label" for="SanctionLatter">Upload Letter</label>
						<span class="required-asterisk">*</span>
						<span><small> (Upload PDF of size upto 25MB) </small></span>
						<div class="custom-file">
							<input type="file" class="form-control custom-file-input" ng2FileSelect [uploader]="uploader"
								id="file-upload-single" (click)="browsbuttonClick('sanctionLatter')" accept=".pdf"
								(change)="uploadFileChange($event, 'sanctionLatter', 25)" formControlName="SanctionLatter"
								[ngClass]="{ 'is-invalid': submitted && !f6.SanctionLatter.valid && isShown }" />
							<label class="custom-file-label" id="sanctionLatter" for="file-upload-single"
								aria-placeholder="Upload file">{{f6.SanctionLatterFileName.value}}</label>
						</div>
						<sup>(Upload PDF of size upto 25MB)</sup>
						<span *ngIf="submitted && f6.SanctionLatter.invalid && isShown" class="invalid-form">
							<small class="form-text text-danger" *ngIf="f6.SanctionLatter.errors.required">This
								field is required!</small>
						</span>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-md-6">
						<label class="form-label" for="orderNo">Order No.</label>
						<span class="required-asterisk">*</span>
						<input formControlName="orderNo" type="text" name="orderNo" id="orderNo" class="form-control"
							placeholder="Order No." [ngClass]="{ 'is-invalid': submitted && !f6.orderNo.valid }"
							[mask]="'^[a-zA-Z0-9_]*$'" />
						<span *ngIf="submitted && f6.orderNo.invalid" class="invalid-form">
							<small class="form-text text-danger" *ngIf="f6.orderNo.errors.required">This
								field is required!</small>
							<small class="form-text text-danger" *ngIf="f6.orderNo.errors.pattern">This
								This field contain atleast one alphanumerical value!</small>
						</span>
					</div>
					<div class="form-group col-md-6">
						<label for="sanctionDate">Date</label>
						<span class="required-asterisk">*</span>
						<fieldset class="form-group">
							<div class="input-group">
								<input class="form-control" placeholder="dd-mm-yyyy" name="sanctionDate"
									formControlName="sanctionDate" ngbDatepicker #MinMaxDP="ngbDatepicker"
									[minDate]="{year: minDate.year, month: minDate.month, day:minDate.day}"
									[maxDate]="{year: maxDate.year, month: maxDate.month, day:maxDate.day}"
									[ngClass]="{ 'is-invalid': submitted && !f6.sanctionDate.valid }" [readonly]="true" />
								<div class="input-group-append">
									<button class="btn btn-outline-secondary feather icon-calendar"
										(click)="MinMaxDP.toggle();" type="button" rippleEffect></button>
								</div>
							</div>
							<span *ngIf="submitted && f6.sanctionDate.invalid" class="invalid-form">
								<small class="form-text text-danger" *ngIf="f6.sanctionDate.errors.required">This
									field is required!</small>
							</span>
						</fieldset>
					</div>
				</div>
				<div class="row">
					<div class="form-group col-md-6">
						<label class="form-label" for="sanctionAmount">Sanctioned Amount (Rs.)</label>
						<span class="required-asterisk">*</span>
						<input formControlName="sanctionAmount" type="text" name="sanctionAmount" id="sanctionAmount" curencyFormat
							class="form-control" placeholder="Amount" [mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'"  (change)="validationForReleasedAmount($event)"
							onKeyPress="if(this.value.length==15) return false;"
							[ngClass]="{ 'is-invalid': submitted && !f6.sanctionAmount.valid }" />
						<span *ngIf="submitted && f6.sanctionAmount.invalid" class="invalid-form">
							<small class="form-text text-danger" *ngIf="f6.sanctionAmount.errors.required">This
								field is required!</small>
						</span>
					</div>
					<div class="form-group col-md-6">
						<label class="form-label" for="releasedAmount">Released Amount (Rs.)</label>
						<span class="required-asterisk">*</span>
						<input formControlName="releaseAmount" type="text" name="releasedAmount" id="releasedAmount" curencyFormat
							class="form-control" placeholder="Amount" [mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'" (change)="validationForReleasedAmount($event)"
							onKeyPress="if(this.value.length==15) return false;"
							[ngClass]="{ 'is-invalid': submitted && !f6.releaseAmount.valid || isFormInvalid}"/>
						<span *ngIf="submitted && f6.releaseAmount.invalid" class="invalid-form">
							<small class="form-text text-danger" *ngIf="f6.releaseAmount.errors.required">This
								field is required!</small>
						</span>
						<span *ngIf="isFormInvalid" class="invalid-form">
							<small class="form-text text-danger">Released amounts should not greater than sanctioned amounts.!</small>
						</span>
					</div>
				</div>
				<dic class="row">
					<div class="form-group col-md-12">
						<label class="form-label" for="majorDeliverables">Major Deliverables</label>
						<span class="required-asterisk">*</span>
						<div class="form-group">
							<textarea type="text" type="text" name="majorDeliverables" id="majorDeliverables" placeholder="Major Deliverables"
								formControlName="majorDeliverables" class="form-control"
								[ngClass]="{ 'is-invalid': submitted && !f6.majorDeliverables.valid }"></textarea>
							<span *ngIf="submitted && f6.majorDeliverables.invalid" class="invalid-form">
								<small class="form-text text-danger" *ngIf="f6.majorDeliverables.errors.required">This
									field is required!</small>
							</span>
						</div>
					</div>
				</dic>
			</div>
			<div *ngIf="isShownRemark">
				<div class="row">
					<div class="col-md-12 form-group">
						<label class="form-label" for="remarks">Remarks</label>
						<span class="required-asterisk">*</span>
						<div class="form-group">
							<textarea type="text" name="Rejectremarks" id="Rejectremarks" placeholder="Remarks"
								formControlName="Rejectremarks" class="form-control" [ngClass]="{ 'is-invalid': submitted && !f6.Rejectremarks.valid }"></textarea>
						</div>
						<span *ngIf="submitted && f6.Rejectremarks.invalid" class="invalid-form">
							<small class="form-text text-danger" *ngIf="f6.Rejectremarks.errors.required">This
								field is required!</small>
							<small class="form-text text-danger" *ngIf="f6.Rejectremarks.errors.pattern">This field contain atleast one alphanumerical value!</small>
						</span>
					</div>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="submit" class="btn btn-primary" (click)="uploadSanctionLatterDocumentData(modal)" rippleEffect>
			Submit
		</button>
	</div>
</ng-template>

<ng-template #modalRR let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="exampleModalCenterTitle">Under Consideration: Raise Request for Mandate Form and
			Upload Bank Details
		</h5>
		<button type="button" class="close" (click)="closeModal(); modal.dismiss('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" tabindex="0" ngbAutofocus>
		<form [formGroup]="raiseRequestform" autocomplete="off">
			<div class="form-group col-md-12">
				<label class="form-label" for="requestStatus">Check below box to raise the request for Mandate from the PI</label>
				<span class="required-asterisk">*</span>
				<div class="demo-inline-spacing" style="margin-top: -15px;">
					<div class="custom-control">
						<input type="checkbox" formControlName="requestStatus"
							[ngClass]="{ 'is-invalid': submitted && !raiseRequestFormData.requestStatus.valid }"
							class="checkboxstyle" />
					</div>
				</div>
				<span *ngIf="submitted && raiseRequestFormData.requestStatus.invalid" class="invalid-form">
					<small class="form-text text-danger" *ngIf="raiseRequestFormData.requestStatus.errors.required">This
						field is required!</small>
				</span>
			</div>
			<div class="form-group col-md-12">
				<label class="form-label" for="requestRemark">Remarks</label>
				<span class="required-asterisk">*</span>
				<div class="form-group">
					<textarea type="text" type="text" name="requestRemark" id="requestRemark"
						[ngClass]="{ 'is-invalid': submitted && !raiseRequestFormData.requestRemark.valid }"
						placeholder="Remark" formControlName="requestRemark" class="form-control"></textarea>
					<span class="invalid-form" *ngIf="submitted && raiseRequestFormData.requestRemark.invalid">
						<small class="form-text text-danger"
							*ngIf="raiseRequestFormData.requestRemark.errors.required">This
							field is required!</small>
					</span>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="submit" class="btn btn-primary" rippleEffect (click)="raiseRequestData(modal)">
			Submit
		</button>
	</div>
</ng-template>

<div class="scrolling-content-inside-modal">
<ng-template #modalSM let-modal>
	<div class="modal-header">
		<h5 *ngIf="isAllowtoDoAction" class="modal-title" id="exampleModalCenterTitle">Message to {{userNameToDisplay}}</h5>
		<h5 *ngIf="!isAllowtoDoAction" class="modal-title" id="exampleModalCenterTitle"> View Message</h5>
		<button type="button" class="close" (click)="closeModal(); modal.dismiss('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" tabindex="0" ngbAutofocus>
		<div class="content-area-wrapper container-xxl p-0">
			<!-- content-right -->
			<div class="content-wrapper container-xxl p-0">
				<div class="content-body">
					<section class="chat-app-window">
						<!-- Active Chat -->
						<div>
						  <!-- User Chat messages -->
						  <div class="user-chats" [perfectScrollbar] #scrollMe [scrollTop]="scrolltop">
							<div class="chats" *ngIf="messageDetail?.length > 0">
							  <div
								class="chat"
								*ngFor="let chatRef of messageDetail"
								[ngClass]="{ 'chat-left': chatRef.fromID != currentUserId }">
								<div class="chat-body">
								  <div class="chat-content">
									<p>{{ chatRef.message }}</p>
								  </div>
								</div>
								<div [ngClass]="chatRef.fromID == currentUserId ? 'msgBy' : 'msgFrom'">{{chatRef.userNameFrom}}  {{chatRef.createdAt}}</div><br />
							  </div>
							</div>
							<div *ngIf="messageDetail?.length == 0">
								<p>No records found.</p>
							</div>
						  </div>
						  <!-- User Chat messages -->
						</div>
						<!--/ Active Chat -->
					  </section>
				</div>
			  </div>
			<!--/ content-right -->
		  </div>
	</div>
	<div class="modal-footer msg-footer">
		<div *ngIf="isAllowtoDoAction">
		<form [formGroup]="sendMessageform" autocomplete="off">
			<div class="row">
				<div class="col-12 col-md-10">
					<fieldset class="form-group">
						<textarea type="text" formControlName="messagetext" class="form-control message" placeholder="Type your message here"
						name="chat-message"></textarea>
					</fieldset>
				</div>
				<div class="col-12 col-md-2">
					<button type="submit" class="btn btn-primary send" (click)="sendMessageData(modal)" rippleEffect>
						<i data-feather="send" class="d-lg-none"></i>
						<span class="d-none d-lg-block">Send</span>
					  </button>
				</div>
			</div>
		 </form>
		</div>
	</div>
</ng-template>
</div>

<ng-template #modalPR let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="exampleModalCenterTitle">Approved/Reject Progress Report
		</h5>
		<button type="button" class="close" (click)="closeModal(); modal.dismiss('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" tabindex="0" ngbAutofocus>
		<form [formGroup]="progressapproveRejectform" autocomplete="off">
			<div class="row">
				<fieldset class="border" style="padding: 0.7rem;">
					<legend class="w-auto">
						<h5 style="margin-top: 7px;">Review Report</h5>
					</legend>
					<table class="table table-striped table-bordered">
						<thead>
							<tr>
								<th> Stage </th>
								<th> Submission Date </th>
								<th> Status </th>
								<th> MNRE Action Date </th>
								<th> Released Amount (Rs.)</th>
								<!-- <th> Download </th> -->
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let item of reviewList">
								<td>
									<a href="Javascript:void(0)"
										(click)="progressReportDetails(modalPRView,item.progressReportId)"><span>{{item?.reviewReportCount}}</span></a>
								</td>
								<td class="text-justify"> {{item?.submitionDate}}</td>
								<td class="text-justify"> {{item?.progressReportStatus}}</td>
								<td class="text-justify"> {{item?.statusDate}}</td>
								<td class="text-justify"> {{item?.releasedAmount}}</td>
							</tr>
							<tr *ngIf="reviewList.length == 0">
								<td colspan="4">No details are available.</td>
							</tr>
						</tbody>
					</table>
				</fieldset>
			</div>
			<div class="row">
				<div class="form-group col-md-6  md-form">
					<label class="form-label" for="gender">Review Report</label>
					<span class="required-asterisk">*</span><br />
					<div class="demo-inline-spacing" *ngFor="let a of this.reviewReportStatus; let $index=index"
						style="margin-top: -15px;">
						<div class="custom-control custom-radio">
							<input type="radio" id="SubjectArea{{$index+1}}" formControlName="SubjectArea"
								name="SubjectArea" class="custom-control-input" value="{{a.value}}"
								(click)="toggleShowReviewReport(a.value)" [ngClass]="{ 'is-invalid': submitted && !prForm.SubjectArea.valid }" />
							<label class="custom-control-label" for="SubjectArea{{$index + 1}}">{{a.label}}</label>
						</div>
					</div>
					<span *ngIf="submitted && prForm.SubjectArea.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="prForm.SubjectArea.errors.required">This
							field is required!</small>
					</span>
				</div>
				<div class="form-group col-md-6 file-field md-form" *ngIf="isShownRejectField">
					<label class="form-label" for="releasedOrderCopy">Released Order Copy</label>
					<span class="required-asterisk">*</span><br />
					<sup>Upload PDF of size upto 25MB</sup>
					<div class="custom-file">
						<input type="file" class="form-control custom-file-input" ng2FileSelect [uploader]="uploader" accept=".pdf"
							id="file-upload-single" (click)="browsbuttonClick()" (change)="uploadPMCfileChange($event, 25,'ReleasedOrderCopy')"
							formControlName="releasedOrderCopy"
							[ngClass]="{ 'is-invalid': submitted && !prForm.releasedOrderCopy.valid }" />
						<label class="custom-file-label" id="releasedOrderCopy"
							for="file-upload-single">{{prForm.releasedOrderCopyName.value}}</label>
					</div>
					<span *ngIf="submitted && prForm.releasedOrderCopy.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="prForm.releasedOrderCopy.errors.required">This
							field is required!</small>
					</span>
				</div>
			<!-- </div>
			<div class="row"> -->
				<div class="form-group col-md-6 file-field md-form" *ngIf="isShownRejectField">
					<label class="form-label" for="MOMdocument">Upload MOM</label>
					<span class="required-asterisk">*</span><br />
					<sup>Upload PDF of size upto 25MB</sup>
					<div class="custom-file">
						<input type="file" class="form-control custom-file-input" ng2FileSelect [uploader]="uploader"
							id="file-upload-single" (click)="browsbuttonClick()" (change)="uploadMOMfileChange($event, 25)"
							formControlName="MOMdocument" accept=".pdf"
							[ngClass]="{ 'is-invalid': submitted && !prForm.MOMdocument.valid }" />
						<label class="custom-file-label" id="MOMdocument"
							for="file-upload-single">{{prForm.MOMdocumentName.value}}</label>
					</div>
					<span *ngIf="submitted && prForm.MOMdocument.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="prForm.MOMdocument.errors.required">This
							field is required!</small>
					</span>
				</div>
				<div class="form-group col-md-6 file-field md-form" *ngIf="!isShownRejectField">
					<label class="form-label" for="PMCdocument">Upload PMC <a href="https://pfms.nic.in/Users/LoginDetails/NewLayoutLogin.aspx" target="_blank">(Redirect to PFMS portal)</a></label>
					<span class="required-asterisk">*</span><br />
					<sup>Upload PDF of size upto 25MB</sup>
					<div class="custom-file">
						<input type="file" class="form-control custom-file-input" ng2FileSelect [uploader]="uploader"
							id="file-upload-single" (click)="browsbuttonClick()" (change)="uploadPMCfileChange($event, 25,'PMC')"
							formControlName="PMCdocument" accept=".pdf"
							[ngClass]="{ 'is-invalid': submitted && !prForm.PMCdocument.valid }" />
						<label class="custom-file-label" id="PMCdocument"
							for="file-upload-single">{{prForm.PMCdocumentName.value}}</label>
					</div>
					<span *ngIf="submitted && prForm.PMCdocument.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="prForm.PMCdocument.errors.required">This
							field is required!</small>
					</span>
				</div>
			<!-- </div>
			<div class="row"> -->
				<div class="form-group col-md-6" *ngIf="isShownRejectField">
					<label class="form-label" for="PRorderNo">Released Order No.</label>
					<span class="required-asterisk">*</span>
					<input formControlName="PRorderNo" type="text" name="PRorderNo" id="PRorderNo" class="form-control"
						placeholder="Order No." [ngClass]="{ 'is-invalid': submitted && !prForm.PRorderNo.valid }" />
					<span *ngIf="submitted && prForm.PRorderNo.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="prForm.PRorderNo.errors.required">This
							field is required!</small>
						<small class="form-text text-danger" *ngIf="prForm.PRorderNo.errors.pattern">This field contain atleast one alphanumerical value!</small>
					</span>
				</div>
				<div class="form-group col-md-6" *ngIf="isShownRejectField">
					<label class="form-label" for="PRamount">Released Amount (Rs.)</label>
					<span class="required-asterisk">*</span>
					<input formControlName="PRamount" type="text" name="PRamount" id="PRamount" class="form-control" curencyFormat 
						placeholder="Amount" [ngClass]="{ 'is-invalid': submitted && !prForm.PRamount.valid }" [mask]="'^[+]?([1-9]\\d*|0)?(\\.\\d\{0,2\})?$'"
						onKeyPress="if(this.value.length==15) return false;"  (change)="validationForReleasedAmountInApproveProgressReport($event)"/>
					<span *ngIf="submitted && prForm.PRamount.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="prForm.PRamount.errors.required">This
							field is required!</small>
					</span>
					<span *ngIf="isPRFormInvalid" class="invalid-form">
						<small class="form-text text-danger">Released amounts should not greater than sanctioned amounts.!</small>
					</span>
				</div>
			<!-- </div>
			<div class="row"> -->
				<div class="form-group col-md-6" *ngIf="isShownRejectField">
					<label for="PRdate">Released Date</label>
					<span class="required-asterisk">*</span>
					<fieldset class="form-group">
						<div class="input-group">
							<input class="form-control" placeholder="dd-mm-yyyy" name="PRdate" formControlName="PRdate"
								ngbDatepicker #MinMaxDP="ngbDatepicker"
								[minDate]="{year: minDate.year, month: minDate.month, day:minDate.day}"
								[maxDate]="{year: maxDate.year, month: maxDate.month, day:maxDate.day}"
								[ngClass]="{ 'is-invalid': submitted && !prForm.PRdate.valid }" [readonly]="true" />
							<div class="input-group-append">
								<button class="btn btn-outline-secondary feather icon-calendar"
									(click)="MinMaxDP.toggle();" type="button" rippleEffect></button>
							</div>
						</div>
						<span *ngIf="submitted && prForm.PRdate.invalid" class="invalid-form">
							<small class="form-text text-danger" *ngIf="prForm.PRdate.errors.required">This
								field is required!</small>
						</span>
					</fieldset>
				</div>
				<div class="form-group col-md-6" *ngIf="isShownRejectField">
					<label class="form-label" for="SNamount">Sanctioned Amount (Rs.)</label>
					<input formControlName="SNamount" type="text" name="SNamount" id="SNamount" class="form-control" curencyFormat 
						placeholder="Amount" readonly/>
				</div>
			<!-- </div> -->
				<!-- <div class="form-group col-md-6" *ngIf="isShownRejectField">
					<label class="form-label" for="PMCMembers">PMC Members</label>
					<input formControlName="PMCMembers" type="text" name="PMCMembers" id="PMCMembers" class="form-control" 
						placeholder="PMC Members" />
				</div> -->
			<!-- <div class="row"> -->
				<div class="form-group col-md-12">
					<label class="form-label" for="PRremarks">Remarks</label>
					<span class="required-asterisk">*</span>
					<div class="form-group">
						<textarea type="text" type="text" name="PRremarks" id="PRremarks" placeholder="Remarks"
							formControlName="PRremarks" class="form-control"
							[ngClass]="{ 'is-invalid': submitted && !prForm.PRremarks.valid }"></textarea>
						<span *ngIf="submitted && prForm.PRremarks.invalid" class="invalid-form">
							<small class="form-text text-danger" *ngIf="prForm.PRremarks.errors.required">This
								field is required!</small>
							<small class="form-text text-danger" *ngIf="prForm.PRremarks.errors.pattern">This field contain atleast one alphanumerical value!</small>
						</span>
					</div>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="submit" class="btn btn-primary" rippleEffect (click)="approveRejectProgressReport(modal)">
			Submit
		</button>
	</div>
</ng-template>

<ng-template #modalPRView let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="exampleModalCenterTitle">View Progress Report
		</h5>
		<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" tabindex="0" ngbAutofocus>
		<form [formGroup]="progreeReportDetailsForm" autocomplete="off">
			<div class="row">
				<div class="form-group col-4">
					<span class="text-justify"><b>Project Title</b> {{progreeReportDetailsForm.get("projectTitle").value}}
					</span>

				</div>
				<div class="form-group col-4">
					<span class="text-justify"><b>Sanction Order No.:</b> {{sanctionDetails.orderNo}}</span>
				</div>
				<div class="form-group col-4">
					<span class="text-justify"><b>Sanction Order Date:</b> {{sanctionDetails.sanctionDate}}</span>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-4">
					<span class="text-justify"><b>Released Order No.:</b> {{releasedOrderNo}}
					</span>

				</div>
				<div class="form-group col-4">
					<span class="text-justify"><b>Released Date:</b> {{releasedDate}}</span>
				</div>
				<div class="form-group col-4">
					<span class="text-justify"><b>Released Amount (Rs.):</b> {{releaseAmount}}</span>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-4">
					<span class="text-justify"><b>Name of PI:</b> {{progreeReportDetailsForm.get("NameOfPI").value}}</span>
				</div>
				<div class="form-group col-4">
					<span class="text-justify"><b>Complete Address of PI:</b>
						{{progreeReportDetailsForm.get("AddressOfPI").value}}</span>
				</div>
				<div class="form-group col-4">
					<span class="text-justify"><b>Project Start Date:</b> {{sanctionDetails.createdDate}}</span>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-4">
					<span class="text-justify"><b>Project End Date:</b> {{sanctionDetails.endDate}}</span>
				</div>
				<div class="form-group col-4">
					<span class="text-justify"><b>Sanctioned Amount (Rs.):</b> {{sanctionDetails.amount}}</span>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-12">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;"></h5>
						</legend>
						<div class="row">
							<div class="form-group col-6 text-justify">
								<span class="text-justify"><b>Actual expenditure as on date enclosing SoE and UC:</b>
									{{progreeReportDetailsForm.get("actualExpenditure").value}}</span>
							</div>
							<div class="form-group col-6 text-justify">
								<span class="text-justify"><b>Approved Objectives of the Project:</b>
									{{progreeReportDetailsForm.get("approvedObjectivesProject").value}}</span>
							</div>
						</div>
						<div class="row">
							<div class="form-group col-6 text-justify">
								<span class="text-justify"><b>Output of the approved Project:</b>
									{{progreeReportDetailsForm.get("outputApprovedProject").value}}</span>
							</div>
							<div class="form-group col-6 text-justify">
								<span class="text-justify"><b>Summary of the Progress reported:</b>
									{{progreeReportDetailsForm.get("summaryProgressReported").value}}</span>
							</div>
						</div>
						<div class="row">
							<div class="form-group col-6 text-justify">
								<span class="text-justify"><b>Detailed Progress:</b>
									{{progreeReportDetailsForm.get("detailedProgress").value}}</span>
							</div>
						</div>
					</fieldset>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-12">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;"></h5>
						</legend>
						<div class="row">
							<div class="form-group col-4 text-justify">
								<span class="text-justify"><b>New observations:</b>
									{{progreeReportDetailsForm.get("newObservations").value}}</span>
							</div>
							<div class="form-group col-4 text-justify">
								<span class="text-justify"><b>Innovations:</b>
									{{progreeReportDetailsForm.get("innovations").value}}</span>
							</div>
							<div class="form-group col-4 text-justify">
								<span class="text-justify"><b>Application Potential:</b>
									{{progreeReportDetailsForm.get("applicationPotential").value}}</span>
							</div>
						</div>
						<div class="row">
							<div class="form-group col-12 text-justify">
								<span class="text-justify"><b>Research / technology development work remaining to be done under the
										project and Work Plan for next six months:</b>
									{{progreeReportDetailsForm.get("projectAndWorkPlan").value}}</span>
							</div>
						</div>
					</fieldset>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-12">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;">Financial Progress Report</h5>
						</legend>
						<div class="row">
							<div class="form-group col-6 text-justify">
								<span class="text-justify"><b>Status of Financial yearwise UC and SoE:</b>
									{{progreeReportDetailsForm.get("statusFinancialYearwise").value}}</span>
							</div>
							<div class="form-group col-3 text-justify">
								<span><b>Download UC letter:</b></span>
								<div *ngIf="progreeReportDetailsForm.get('UCletter').value" class="download-file"
									style="width: 50%; float: right;">
									<a href="{{progreeReportDetailsForm.get('UCletter').value}}"
										target="_blank"><i
											class="custom-control-inline feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download Document"></i></a>
								</div>
							</div>
							<div class="form-group col-3 text-justify">
								<span><b>Download SOE letter:</b> </span>
								<div *ngIf="progreeReportDetailsForm.get('SOEletter').value" class="download-file"
									style="width: 50%; float: right;">
									<a href="{{progreeReportDetailsForm.get('SOEletter').value}}"
										target="_blank"><i
											class="custom-control-inline feather avatar-icon font-medium-1 icon-arrow-down-circle"
											title="Download Document"></i></a>
								</div>
							</div>
						</div>
					</fieldset>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-6">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;">Total funds released by MNRE</h5>
						</legend>
						<table class="table table-striped table-bordered">
							<thead>
								<tr>
									<th>Sanction No.</th>
									<th>Date</th>
									<th>Amount (Rs.)</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td class="text-justify">{{sanctionDetails.orderNo}}</td>
									<td class="text-justify">{{sanctionDetails.sanctionDate}}</td>
									<td class="text-justify">{{sanctionDetails.amount}}</td>
								</tr>
							</tbody>
						</table>
					</fieldset>
				</div>
				<div class="form-group col-6">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;">Status of Manpower</h5>
						</legend>
						<table class="table table-striped table-bordered">
							<thead>
								<tr>
									<th>SANCTIONED LIST</th>
									<th>IN POSITION (YES/ NO)</th>
									<th>SCALE</th>
									<th>REMARKS (GIVE REASONS FOR NEGATIVE RESPONSE)</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let item of manpowerArray; let $index=index">
									<td class="text-justify">{{item.sanctionList}}</td>
									<td class="text-justify">{{item.inPosition}}</td>
									<td class="text-justify">{{item.scale}}</td>
									<td class="text-justify">{{item.remarks}}</td>
								</tr>
								<tr *ngIf="manpowerArray.length == 0">
									<td colspan="4">No details are available.</td>
								</tr>
							</tbody>
						</table>
					</fieldset>
				</div>
			</div>
			<div class="row">
				<div class="form-group col-12">
					<fieldset class="border" style="padding: 0.7rem;">
						<legend class="w-auto">
							<h5 style="margin-top: 7px;">Status of Equipment Procurement</h5>
						</legend>
						<table class="table table-striped table-bordered">
							<thead>
								<tr>
									<th>SANCTIONED ITEMS OF EQUIPMENT</th>
									<th>PROCUREMENT STATUS (YES/ NO) MODEL & MAKE, DATE OF PROCUREMENT &
										COMMISSIONING</th>
									<th>COST (RS.)</th>
									<th>WORKING (YES/ NO)</th>
									<th>REMARKS (GIVE REASONS FOR NEGATIVE RESPONSE)</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let item of prEquipmentDetailsArray; let $index=index">
									<td class="text-justify">{{item.sanctionItemsOfEquipment}}</td>
									<td class="text-justify">{{item.procurementStatus}}</td>
									<td class="text-justify">{{item.equipmentCost}}</td>
									<td class="text-justify">{{item.workingStatus}}</td>
									<td class="text-justify">{{item.remarks}}</td>
								</tr>
								<tr *ngIf="prEquipmentDetailsArray.length == 0">
									<td colspan="5">No details are available.</td>
								</tr>
							</tbody>
						</table>
					</fieldset>
				</div>
			</div>
		</form>
	</div>

</ng-template>

<ng-template #modalPU let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="exampleModalCenterTitle">Update Profile Data</h5>
	</div>
	<div class="modal-body" tabindex="0" ngbAutofocus>
		<form [formGroup]="updateProfileForm" autocomplete="off">
			<div class="row">
				<div class="form-group col-md-6">
					<label class="form-label" for="department">Title<span
						class="required-asterisk">*</span></label>
					<input formControlName="title" type="text" name="title"
						id="title" class="form-control" placeholder="Title" [ngClass]="{ 'is-invalid': submitted && !profileData.title.valid }" />
					<span *ngIf="submitted && profileData.title.invalid"
						class="invalid-form">
						<small class="form-text text-danger" *ngIf="profileData.title.errors.required">This field is required!</small>
						<small class="form-text text-danger" *ngIf="profileData.title.errors.pattern">This field contain atleast one alphanumerical value!</small>
					</span>
				</div>
				<div class="form-group col-md-6">
					<label class="form-label" for="department">Date Of Birth<span
						class="required-asterisk">*</span></label>
					<div class="input-group">
						<input class="form-control" placeholder="dd-mm-yyyy" name="dateOfBirth"
							formControlName="dateOfBirth" ngbDatepicker #MinMaxDP="ngbDatepicker"
							[minDate]="{year: minDOBDate.year, month: minDOBDate.month, day:minDOBDate.day}"
							[readonly]="true" [ngClass]="{ 'is-invalid': submitted && !profileData.dateOfBirth.valid }"/>
						<div class="input-group-append">
							<button class="btn btn-outline-secondary feather icon-calendar form-control"
								(click)="setStartMinDate(); MinMaxDP.toggle();" type="button"
								rippleEffect></button>
						</div>
					</div>
					<span *ngIf="submitted && profileData.dateOfBirth.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="profileData.dateOfBirth.errors.required">This
							field is required!</small>
					</span>
				</div>
				<div class="form-group col-md-6">
					<label class="form-label"
						for="department">Department<span
						class="required-asterisk">*</span></label>
					<input formControlName="department" type="text"
						name="department" id="department" class="form-control"
						placeholder="Department"  [ngClass]="{ 'is-invalid': submitted && !profileData.department.valid }"/>
					<span *ngIf="submitted && profileData.department.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="profileData.department.errors.required">This field is required!</small>
						<small class="form-text text-danger" *ngIf="profileData.department.errors.pattern">This field contain atleast one alphanumerical value!</small>
					</span>
				</div>
				<div class="form-group col-md-6">
					<label class="form-label"
						for="designation">Designation<span
						class="required-asterisk">*</span></label>
					<input formControlName="designation" type="text"
						name="designation" id="designation" class="form-control"
						placeholder="Designation" [ngClass]="{ 'is-invalid': submitted && !profileData.designation.valid }"/>
					<span *ngIf="submitted && profileData.designation.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="profileData.designation.errors.required">This field is required!</small>
						<small class="form-text text-danger" *ngIf="profileData.designation.errors.pattern">This field contain atleast one alphanumerical value!</small>
					</span>	
				</div>
				<div class="form-group col-md-6">
					<label class="form-label" for="institute">Institute<span
						class="required-asterisk">*</span></label>
					<input formControlName="institute" type="text"
						name="institute" id="institute" class="form-control"
						placeholder="Institute Name" [ngClass]="{ 'is-invalid': submitted && !profileData.institute.valid }"/>
					<span *ngIf="submitted && profileData.institute.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="profileData.institute.errors.required">This field is required!</small>
						<small class="form-text text-danger" *ngIf="profileData.institute.errors.pattern">This field contain atleast one alphanumerical value!</small>
					</span>
				</div>
				<div class="form-group col-md-6">
					<label class="form-label" for="gender">Gender</label>
					<div class="demo-inline-spacing" style="margin-top: -15px;">
						<div class="custom-control custom-radio">
							<input type="radio" id="genderM"
								formControlName="gender" name="gender"
								class="custom-control-input" value="M" [ngClass]="{ 'is-invalid': submitted && !profileData.gender.valid }"/>
							<label class="custom-control-label"
								for="genderM">Male</label>
						</div>
						<div class="custom-control custom-radio">
							<input type="radio" id="genderF"
								formControlName="gender" name="gender"
								class="custom-control-input" value="F" [ngClass]="{ 'is-invalid': submitted && !profileData.gender.valid }"/>
							<label class="custom-control-label"
								for="genderF">Female</label>
						</div>
						<div class="custom-control custom-radio">
							<input type="radio" id="genderO"
								formControlName="gender" name="gender"
								class="custom-control-input" value="O" [ngClass]="{ 'is-invalid': submitted && !profileData.gender.valid }"/>
							<label class="custom-control-label"
								for="genderO">Other</label>
						</div>
						<span *ngIf="submitted && profileData.gender.invalid" class="invalid-form">
							<small class="form-text text-danger" *ngIf="profileData.gender.errors.required">This field is required!</small>
						</span>
					</div>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="submit" class="btn btn-primary"  (click)="submitProfileData(modal)" rippleEffect>
			Submit
		</button>
	</div>
</ng-template>

<ng-template #modalUDC let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="exampleModalCenterTitle">Documents</h5>
		<button type="button" class="close" (click)="closeModal(); modal.dismiss('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" tabindex="0" ngbAutofocus>
		<form [formGroup]="uploaddocumentform" autocomplete="off">
			<div class="form-group col-md-12">
				<label class="form-label" for="uploadDocument">Upload Document</label>
				<span class="required-asterisk">*</span>
				<div class="form-group">
					<div class="custom-file">
						<input type="file" class="form-control custom-file-input" ng2FileSelect [uploader]="uploader"
							id="file-upload-single" accept=".pdf" (click)="browsbuttonClick('uploaddocument')"
							(change)="uploadFileChange($event, 'uploaddocument',25)" formControlName="Document"
							[ngClass]="{ 'is-invalid': submitted && !f7.Document.valid }" />
						<label class="custom-file-label" id="Document" for="file-upload-single"
							aria-placeholder="Upload file">{{f7.DocumentName.value}}</label>
					</div>
					<sup>(Upload PDF of size upto 25MB)</sup>
					<span *ngIf="submitted && f7.Document.invalid" class="invalid-form">
						<small class="form-text text-danger" *ngIf="f7.Document.errors.required">This
							field is required!</small>
					</span>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="submit" class="btn btn-primary" (click)="uploadApplicationDocument(modal)" rippleEffect>
			Submit
		</button>
	</div>
</ng-template>

<ng-template #modalEAR let-modal>
	<div class="modal-header">
		<h5 class="modal-title" id="exampleModalCenterTitle">Remarks</h5>
		<button type="button" class="close" (click)="closeModal(); modal.dismiss('Cross click')" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" tabindex="0" ngbAutofocus>
		<form [formGroup]="acceptRejectExpertComments" autocomplete="off">
			<div class="form-group col-md-12">
				<label class="form-label" for="uploadDocument">Remark</label>
				<span class="required-asterisk">*</span>
				<div class="form-group">
					<textarea type="text" name="expertCommentsRemark" id="expertCommentsRemark" placeholder="Remarks" formControlName="expertCommentsRemark" class="form-control" [ngClass]="{ 'is-invalid': expertStatusSubmitted && !acceptRejectExpertComments.controls.expertCommentsRemark.valid }"></textarea>
					<span *ngIf="expertStatusSubmitted && !acceptRejectExpertComments.controls.expertCommentsRemark.valid" class="invalid-form">
						<small class="form-text text-danger">This field is required!</small>
					</span>
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="submit" class="btn btn-primary" (click)="submitExpertStatusRemark(modal,modalAR)" rippleEffect>
			Submit
		</button>
	</div>
</ng-template>
